import { Axios } from './../shared/Axios';
import qs from 'qs';

class AdminService extends Axios {

    private static instance: AdminService;

    static get(): AdminService {
        if (!AdminService.instance) {
            AdminService.instance = new AdminService();
        }
        return AdminService.instance;
    }

    async getAdmins(data: object): Promise<any> {
        return this.instance.get(`/admin/admin${qs.stringify(data, { addQueryPrefix: true })}`)
    }

    async updateAdmin(data: object, id: number): Promise<any> {
        return this.instance.patch(`/admin/admin/${id}`, data, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
    }

    async saveAdmin(data: object): Promise<any> {
        return this.instance.post(`/admin/admin`, data, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
    }


    async deleteAdmin(id: number): Promise<any> {
        return this.instance.delete(`/admin/admin/${id}`)
    }


    async getActivityLogs(data: object): Promise<any> {
        return this.instance.get(`/admin/admin/logs/activity${qs.stringify(data, { addQueryPrefix: true })}`)
    }


}


const adminService = AdminService.get();

export { adminService as AdminService }